import { FilterVM } from '../../../common/view-model';
import './NewCategoryBreadcrumbComponent.scss';
import { toTitleCase } from '../../../helpers/formatTextTitleCase';
import { useAppDispatch } from '../../../redux/store';
import { useNavigate } from 'react-router';
import { FilterActions } from '../../../redux/FilterActions';
interface INewCategoryBreadcrumbComponentProps {
	lastSelectedCategory?: FilterVM;
}
const ALL_PRODUCTS_TEXT = 'All Products';
const NAVIGATION_URL = '/products';
export const NewCategoryBreadcrumbComponent: React.FC<INewCategoryBreadcrumbComponentProps> = ({
	lastSelectedCategory
}) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const handleNavigate = () => {
		dispatch(FilterActions.clearAllFiltersAndSearchTerm());
		navigate(NAVIGATION_URL);
	};
	return (
		<div className='category-breadcrumb-container'>
			<button
				type='button'
				className='category-breadcrumb-text first-level'
				onClick={handleNavigate}
			>
				{ALL_PRODUCTS_TEXT}
			</button>
			{lastSelectedCategory && (
				<>
					<i className='ri-arrow-right-s-line icon'></i>
					<span className='category-breadcrumb-text second-level'>
						{toTitleCase(lastSelectedCategory?.name ?? '')}
					</span>
				</>
			)}
		</div>
	);
};
